import stackBindVueComponent from './vue-components/helpers/mountVueComponent.js'
import ArticleListing from './vue-components/content-card-listing/articles.vue'

stackBindVueComponent(ArticleListing.placeholderId, ArticleListing)
